import { seoConfig } from '@shared/configs';

import { SelectionApi } from '@entities/selection';

import type { PageLoad } from './$types';

export const load: PageLoad = async ({ fetch, params, url }) => {
  const { searchParams } = url;
  const { slug } = params;

  const token = searchParams.get('token');

  const selectionApi = new SelectionApi(fetch);

  const selection = token ? await selectionApi.readOnePrivate(token) : await selectionApi.readOnePublic(slug);

  const breadcrumbs = [
    {
      name: 'Home',
      slug: '/',
      canonical: false,
    },
    {
      name: 'Selections',
      slug: '/selections/',
      canonical: false,
    },
    {
      name: selection.title,
      slug: `/selection-${slug}/`,
      canonical: true,
    },
  ];

  const seo = seoConfig.selection({
    breadcrumbs,
    selectionTitle: selection.title,
  });

  return {
    selection,
    seo,
  };
};
